import { FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useTranslate } from 'hooks/useTranslate';

import Page from 'modules/_shared/components/Pages/Page';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import Breadcrumb, {
  BreadcrumbItem,
} from 'modules/_shared/components/Breadcrumb';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import { IncentiveOfferType } from 'modules/incentivesMarket/types';
import { useAddIncentiveOfferPage } from './context/AddIncentiveOfferPageContext';
import AddIncentiveOfferPageBody from './components/AddIncentiveOfferPageBody';
import { addIncentiveOfferLabels } from './constants/addIncentiveOfferLabels';

const AddIncentiveOfferPage: FC = () => {
  const { t } = useTranslate();
  const location = useLocation();
  const beneficiaryQuery = new URLSearchParams(location.search).get('beneficiaryId');
  const pq = beneficiaryQuery ? `?beneficiaryId=${beneficiaryQuery}` : '';

  const { data } = useAddIncentiveOfferPage();

  const { incentiveOfferType } = data;

  const labels = useMemo(
    () => addIncentiveOfferLabels[incentiveOfferType as IncentiveOfferType],
    [incentiveOfferType]
  );

  const breadcrumbItems: BreadcrumbItem[] = useMemo(
    () => [
      { label: t('Dashboard'), to: '/' },
      { label: data.societyName, to: `/sociedad/${data.societyId}` },
      {
        label: t('IncentivesMarket'),
        to: `/mercado-de-incentivos/${data.societyId}${pq}`,
      },
      {
        label: t(labels.BREADCRUMB),
        isActive: true,
      },
    ],
    [t, data.societyName, data.societyId, labels.BREADCRUMB, pq]
  );

  const pageActions = [<GoBackButton key="go-back" icon="ni-arrow-left" />];

  return (
    <Page>
      <div className="nk-block-head-content mb-3">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <PageListHeader
        subTitle={t(labels.TITLE)}
        description={t(labels.DESCRIPTION)}
        actions={pageActions}
      />

      <AddIncentiveOfferPageBody />

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default AddIncentiveOfferPage;
